import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { GameProvider } from './state/GameProvider';
import { Nav } from './components/Nav';
import { ClaimToast } from './components/ClaimToast';
import { Collection } from './routes/Collection';
import { Trips } from './routes/Trips';
import { Settings } from './routes/Settings';

export function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GameProvider>
        <div className="shell">
          <Routes>
            <Route path="/" element={<Collection />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Collection />} />
          </Routes>
        </div>
        <ClaimToast />
        <Nav />
      </GameProvider>
    </BrowserRouter>
  );
}
